<template>
  <div class="layout-catalog-categories">
    <div class="container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.layout-catalog-categories {
}
.container {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-auto-rows: 12em;
  gap: 0.8em;
}

@media screen and (max-width: 767px) {
  .container {
    display: block;
    padding: 0 var(--gap);
    & > * {
      height: 20em;
      margin-bottom: 0.5em;
    }
  }
}
</style>
